/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant, isBoolean, flatten, uniq, each, get } from 'underscore';
import { MessageBar, Checkbox, Link } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@bingads-webui-react/primitive';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { Loading } from '@bingads-webui-campaign-react/loading';
import { Panel } from '@bingads-webui-campaign-react/panel';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { getLocalStorage } from '@bingads-webui/storage';
import { getRoutePathById, siteMapPropType, withSiteMap } from '@bingads-webui-campaign-react/with-site-map';
import * as createService from '@bingads-webui-campaign-legacy/campaign-create-advanced/view/service';
import { bytesForHuman, targetConstraintsToText, getCountriesLocations, getTargetConstraints, getVideoConstraintDuration, MTCurrencyConvertor, isNetflixDeal } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { getChooseAdsPanelStyles } from '../styles';
import { StyledAdTypeItem } from './ad-type-item';
import { DealFilterBar } from './deal-filter-bar';
import {
  adTypeConfig,
  shoppingCampaignTypeConfig,
  perfMaxCampaignTypeConfig,
  standardShoppingCampaignTypeConfig,
  shoppingCampaignTypes,
  xandrVideoCampaignTypeConfig,
  adImpressionsCampaignTypeConfig,
  getDeals,
  getDealsV2,
  sponsoredProductCampaignTypeConfig,
} from '../helper';

const NFDealAccountPreferenceName = 'WebApp.CampaignUI.AcceptNetflixDealTCs';
let noSmartShoppingReasonRef = null;

class ChooseAdsPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.createService = createService;

    this.localStorage = getLocalStorage();
    this.isLocalStorageSupported = this.localStorage.supportsStorage();
    if (this.isLocalStorageSupported) {
      this.localStorage.invalidate('XandrVideoCampaignType');
    }

    this.state = {
      selectedAdType: null,
      selectedVideoChannelType: null,
      selectedAdImpressionsType: null,
      selectedCampaignType: null,
      selectedSponsoredProductCampaignType: null,
      showShoppingCampaignTypeOptions: false,
      showPerfMaxCampaignTypeOptions: props.showPerfMaxCampaignTypeOptions,
      isPerfMaxCampaignDisabled: false,
      netflixDealTCAccepted: this.isAcceptNetflixDealTCs(props),
      deals: [],
      filteredDeals: [],
      isSmartShoppingCampaignDisabled: false,
      loading: true,
      locationMap: {},
      locationFilterOptions: [],
      smartShoppingNotSupportedReason: null,
      itemId: props.itemId,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.itemId !== prevState.itemId) {
      const { itemId, showPerfMaxCampaignTypeOptions } = nextProps;
      const selectedCampaignType = showPerfMaxCampaignTypeOptions ? null : shoppingCampaignTypes.smart;
      if (itemId === 'ShoppingCampaign' && nextProps.isSmartShoppingCampaignEnabled) {
        return {
          loading: true,
          selectedCampaignType,
          showShoppingCampaignTypeOptions: false,
          showPerfMaxCampaignTypeOptions: nextProps.showPerfMaxCampaignTypeOptions,
          itemId,
        };
      } else if (itemId === 'MediaPackageCampaign') {
        return {
          loading: !prevState.deals || prevState.deals.length === 0,
          itemId,
        };
      }

      return {
        selectedAdType: null,
        selectedCampaignType,
        showShoppingCampaignTypeOptions: false,
        showPerfMaxCampaignTypeOptions: nextProps.showPerfMaxCampaignTypeOptions,
        loading: nextProps.showPerfMaxCampaignTypeOptions,
        itemId,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.fetchIsSmartShoppingCampaignEnabled(this.props);
      this.fetchIsPerfMaxCampaignEnabled(this.props);
      this.fetchDeals(this.props);
    }
  }

  get adTypes() {
    const { i18n } = this.props;
    return adTypeConfig(i18n);
  }

  get shopppingCampaignTypes() {
    const { i18n, permissions } = this.props;
    return shoppingCampaignTypeConfig(i18n, permissions);
  }

  get perfMaxCampaignType() {
    const { i18n } = this.props;
    return perfMaxCampaignTypeConfig(i18n);
  }

  get standardCampaignType() {
    const { i18n } = this.props;
    return adTypeConfig(i18n, true)[0];
  }

  get audienceCampaignType() {
    const { i18n } = this.props;
    return adTypeConfig(i18n, true)[1];
  }

  get standardShoppingCampaignType() {
    const { i18n } = this.props;
    return standardShoppingCampaignTypeConfig(i18n);
  }

  get xandrVideoCampaignType() {
    const { i18n } = this.props;
    return xandrVideoCampaignTypeConfig(i18n);
  }

  get adImpressionCampaignType() {
    const { i18n } = this.props;
    return adImpressionsCampaignTypeConfig(i18n);
  }

  getPanelTitle() {
    if (this.state.loading) {
      return '';
    }
    const { i18n, itemId } = this.props;

    if (itemId === 'MediaPackageCampaign') {
      return i18n.getString(_TL_('Choose your deal'));
    }

    const shoppingCampaignSubTypeTitle = i18n.getString(_TL_('Select a campaign type.'));
    const campaignTypeTitle = i18n.getString(_TL_('What kind of ads do you want to run for this campaign?'));
    return this.state.showShoppingCampaignTypeOptions || this.state.showPerfMaxCampaignTypeOptions ? shoppingCampaignSubTypeTitle : campaignTypeTitle;
  }

  getConversionGoalWarningMessage(isPerfMaxCampaign) {
    const {
      classes, scope, siteMap, i18n,
    } = this.props;

    return (
      <div className={classes.smartShoppingWarning}>
        <h3>{i18n.getString(_TL_('Missing conversion tracking'))}</h3>
        {i18n.getString(_TL_('To run a {{campaignType}}, you need conversion tracking so you can keep track of when your ads lead to sales on your website.'), {
          campaignType: isPerfMaxCampaign ? i18n.getString(_TL_('Performance Max campaign')) : i18n.getString(_TL_('Smart Shopping campaign')),
        })}
        <a
          role="link"
          className={classes.smartShoppingWarningLink}
          onClick={(evt) => {
            evt.preventDefault();
            const pathname = getRoutePathById(siteMap, 'conversion-goals');

            scope.history.push({
              pathname,
              search: scope.history.location.search,
            });
          }}
        >
          {i18n.getString(_TL_('Set up conversion tracking'))}
        </a>
      </div>
    );
  }

  getSmartShoppingWarningMessage() {
    const { classes, i18n } = this.props;
    switch (this.state.smartShoppingNotSupportedReason) {
      case noSmartShoppingReasonRef.NO_AVAILABLE_GOAL:
        return this.getConversionGoalWarningMessage();
      case noSmartShoppingReasonRef.MORE_THAN_100:
        return (
          <div className={classes.smartShoppingWarning}>
            <h3>{i18n.getString(_TL_('Campaign limit reached'))}</h3>
            {i18n.getString(_TL_('The maximum number of Smart Shopping campaigns allowed per account is 100.'))}
          </div>
        );
      default:
        return '';
    }
  }

  async fetchDeals(props) {
    if (props.permissions.IsDealEnabledForMsAds) {
      if (this.state.deals && this.state.deals.length > 0) {
        return;
      }
      const { itemId, scope, serverContext } = props;
      const { cid, aid } = scope.values;
      const lcid = serverContext ? serverContext.CurrentUser.LocaleID : '1033';

      if (itemId === 'MediaPackageCampaign') {
        let deals;
        if (props.permissions.IsEnabledDealsV2) {
          deals = await getDealsV2(cid, aid).then(response => response.value);
        } else {
          deals = await getDeals();
        }
        const locationIds = uniq(flatten(deals.map(deal => getTargetConstraints(deal, 'Location').mandatory)));

        const locationResponse = await getCountriesLocations(locationIds, lcid, cid, aid);
        const locationMap = {};
        const locationFilterOptions = [];
        each(locationResponse, (location) => {
          if (!locationMap[location.data.Id]) {
            locationFilterOptions.push({ key: location.data.CountryCode, text: location.data.EnglishName, data: location.data });
          }
          locationMap[location.data.Id] = location.data.EnglishName;
        });

        this.setState({
          loading: false,
          locationMap,
          locationFilterOptions,
          deals,
          filteredDeals: deals,
        });
      }
    }
  }

  fetchIsSmartShoppingCampaignEnabled(props) {
    const { itemId, showPerfMaxCampaignTypeOptions, isSmartShoppingCampaignEnabled } = props;
    if (itemId === 'ShoppingCampaign') {
      if (isSmartShoppingCampaignEnabled) {
        this.fetchIsSmartShoppingCampaignSupportedWithLegacyCode().then(({ supported, reason }) => {
          if (this.props.itemId === itemId) {
            const showShoppingCampaignTypeOptions = supported || reason !== noSmartShoppingReasonRef.NO_PILOT;
            this.setState({
              loading: false,
              showShoppingCampaignTypeOptions,
              selectedAdType: null,
              isSmartShoppingCampaignDisabled: !supported && reason !== noSmartShoppingReasonRef.NO_PILOT,
              smartShoppingNotSupportedReason: reason,
            });
            if (!showPerfMaxCampaignTypeOptions) {
              this.setState({
                selectedCampaignType: supported ? shoppingCampaignTypes.smart : shoppingCampaignTypes.standard,
              });
            }
          }
        });
      } else if (this.props.itemId === itemId) {
        this.setState({
          loading: false,
          showShoppingCampaignTypeOptions: true,
          isSmartShoppingCampaignDisabled: true,
          selectedAdType: null,
        });
        if (!showPerfMaxCampaignTypeOptions) {
          this.setState({
            selectedCampaignType: shoppingCampaignTypes.standard,
          });
        }
      }
    }
  }

  fetchIsPerfMaxCampaignEnabled(props) {
    const { showPerfMaxCampaignTypeOptions } = props;

    if (showPerfMaxCampaignTypeOptions) {
      this.setState({
        loading: false,
        isPerfMaxCampaignDisabled: false,
      });
    }
  }

  fetchIsSmartShoppingCampaignSupportedWithLegacyCode() {
    return new Promise((resolve) => {
      const { fetchIsSmartShoppingCampaignSupported, noSmartShoppingReason } = this.createService;
      resolve(fetchIsSmartShoppingCampaignSupported());
      noSmartShoppingReasonRef = noSmartShoppingReason;
    });
  }

  handleNextButtonClick = () => {
    const {
      handleNavigation, permissions, config, preferenceService,
    } = this.props;
    const {
      selectedVideoChannelType,
      itemId,
      netflixDealTCAccepted,
      selectedDeal,
      selectedAdImpressionsType,
      selectedSponsoredProductCampaignType,
    } = this.state;
    if (itemId === 'VideoCampaign') {
      config.set('XandrVideoCampaignType', selectedVideoChannelType);

      if (this.isLocalStorageSupported) {
        this.localStorage.set('XandrVideoCampaignType', selectedVideoChannelType);
      }
      handleNavigation('VideoCampaign');
    } else if (itemId === 'MediaPackageCampaign') {
      config.set('VideoMediaDeal', selectedDeal);

      if (netflixDealTCAccepted && this.isNetflixDealSelected()) {
        preferenceService.setAtAccountLevel({
          Name: NFDealAccountPreferenceName,
          Data: true,
          Type: 'bool',
          Version: 1,
        });
      }

      if (this.isLocalStorageSupported) {
        this.localStorage.set('VideoMediaDeal', selectedDeal);
      }

      handleNavigation('VideoCampaign');
    } else if (itemId === 'AdImpressions') {
      handleNavigation(selectedAdImpressionsType);
    } else if (itemId === 'SponsoredShoppingCampaign') {
      handleNavigation(selectedSponsoredProductCampaignType);
    } else if (this.state.showPerfMaxCampaignTypeOptions) {
      if (this.state.showShoppingCampaignTypeOptions && this.state.selectedCampaignType === shoppingCampaignTypes.standard) {
        if (permissions.IsAIMCampaignEnabled) {
          this.setState({
            showPerfMaxCampaignTypeOptions: false,
            showShoppingCampaignTypeOptions: false,
          });
        } else {
          handleNavigation('SearchAds');
        }
      } else {
        const { selectedCampaignType } = this.state;
        handleNavigation(selectedCampaignType);
      }
    } else if (!this.state.showShoppingCampaignTypeOptions) {
      const { selectedAdType } = this.state;

      handleNavigation(selectedAdType);
    } else if (this.state.selectedCampaignType === shoppingCampaignTypes.standard) {
      if (permissions.IsAIMCampaignEnabled) {
        this.setState({
          showShoppingCampaignTypeOptions: false,
        });
      } else {
        handleNavigation('SearchAds');
      }
    } else {
      const { selectedCampaignType } = this.state;
      handleNavigation(selectedCampaignType);
    }
  };

  handleAdTypeSelect = (adTypeId) => {
    this.setState({ selectedAdType: adTypeId });
  };

  handleCampaignTypeSelect = (id) => {
    this.setState({ selectedCampaignType: id });
  };

  handleShoppingCampaignTypeSelect = (id) => {
    this.setState({ selectedCampaignType: id });
  };

  handleXanerVideoCampaignChannelSelect = (id) => {
    this.setState({ selectedVideoChannelType: id });
  };

  handleSponsoredProductCampaignTypeSelect = (id) => {
    this.setState({ selectedSponsoredProductCampaignType: id });
  };

  handleDealSelect = (deal) => {
    this.setState({ selectedDeal: deal });
  };

  handleAdImpressionsCampaignChannelSelect = (id) => {
    this.setState({ selectedAdImpressionsType: id });
  };

  handleCheckNFDealIterm = async () => {
    this.setState({
      netflixDealTCAccepted: !this.state.netflixDealTCAccepted,
    });
  };

  handleDealFilter = (filteredDeals) => {
    this.setState({
      filteredDeals,
    });
  };

  isAcceptNetflixDealTCs = (props) => {
    const { preferenceService } = props;
    return get(preferenceService.findByNameAtAccountLevel(NFDealAccountPreferenceName), 'Data', false);
  };

  isNetflixDealSelected = () => this.state.selectedDeal && isNetflixDeal(this.state.selectedDeal);

  isNextButtonDisabled() {
    const {
      selectedAdType,
      selectedCampaignType,
      loading,
      itemId,
      selectedDeal,
      netflixDealTCAccepted,
      selectedAdImpressionsType,
      selectedVideoChannelType,
      selectedSponsoredProductCampaignType,
    } = this.state;
    if (loading) {
      return true;
    }

    if (this.state.showShoppingCampaignTypeOptions) {
      return selectedCampaignType == null;
    }
    if (this.state.showPerfMaxCampaignTypeOptions) {
      return selectedCampaignType == null;
    }
    if (itemId === 'VideoCampaign') {
      return selectedVideoChannelType == null;
    }
    if (itemId === 'MediaPackageCampaign') {
      return selectedDeal == null || (this.isNetflixDealSelected() && !netflixDealTCAccepted);
    }
    if (itemId === 'AdImpressions') {
      return selectedAdImpressionsType == null;
    }
    if (itemId === 'SponsoredShoppingCampaign') {
      return selectedSponsoredProductCampaignType == null;
    }
    if (!this.state.showShoppingCampaignTypeOptions) {
      return selectedAdType == null;
    }

    return false;
  }

  renderOptions() {
    const { i18n, permissions, isSmartShoppingCampaignEnabled } = this.props;
    const {
      selectedCampaignType,
      selectedVideoChannelType,
      selectedAdImpressionsType,
      selectedSponsoredProductCampaignType,
      itemId,
      selectedDeal,
      filteredDeals,
      deals,
      isPerfMaxCampaignDisabled,
      locationMap,
    } = this.state;
    let campaignTypeOptions = [];
    const { selectedAdType } = this.state;

    if (permissions.IsDomesticSimplifiedChineseEnabled) {
      const campaignTypesToShow = [this.standardCampaignType];
      if (itemId !== 'ShoppingCampaign') {
        campaignTypesToShow.push(this.audienceCampaignType);
      }
      return campaignTypesToShow.map((campaigntype, index) =>
      (
        <StyledAdTypeItem
          key={campaigntype.id}
          onSelect={this.handleAdTypeSelect}
          isSelected={selectedAdType === campaigntype.id}
          ariaItemIndex={index + 1}
          ariaItemSize={campaigntype.length}
          i18n={i18n}
          {...campaigntype}
        />
      ));
    }

    if (itemId === 'VideoCampaign') {
      campaignTypeOptions = this.xandrVideoCampaignType.map((item, index) => (
        <StyledAdTypeItem
          key={item.id}
          onSelect={this.handleXanerVideoCampaignChannelSelect}
          isSelected={selectedVideoChannelType === item.id}
          ariaItemIndex={index + 1}
          i18n={i18n}
          {...item}
        />
      ));
      return campaignTypeOptions;
    }

    if (itemId === 'MediaPackageCampaign') {
      const displayDeals = permissions.IsDealFilterEnabled ? filteredDeals : deals;
      const options = displayDeals.map((item, index) => {
        const hideDealImpression = isNetflixDeal(item);
        const isDealGenreRestricted = get(permissions, 'IsDealFilterEnabled', false);

        const configItem = {
          id: item.Id,
          title: item.Name,
          description: (
            <div className="deal-description" >
              {!hideDealImpression && item.EstimatedImpressions && <div style={{ fontSize: 14, color: '#605E5C', fontWeight: 'bold' }} >{i18n.getString(_TL_('Estimated Impressions'))}: {bytesForHuman(item.EstimatedImpressions)}</div>}
              <div>{i18n.getString(_TL_('Deal Id'))}: {item.Id}</div>
              {/* todos: get location by ids */}
              <div>{i18n.getString(_TL_('Country'))}: {targetConstraintsToText(item, 'Location', i18n, locationMap)}</div>
              {
                item.MinimumBid ?
                  <div>{i18n.getString(_TL_('Minimum bid'))}: {decimal.fromFloatToString(item.MinimumBid, 2)} {MTCurrencyConvertor[item.Currency] || 'USD'}</div> :
                  <div>{i18n.getString(_TL_('Minimum bid'))}: {i18n.getString(_TL_('Unavailable'))}</div>
              }
              <div>{i18n.getString(_TL_('Duration'))}: {getVideoConstraintDuration(item, i18n)}</div>
              <div>{i18n.getString(_TL_('Gender targeting'))}: {targetConstraintsToText(item, 'Gender', i18n)}</div>
              <div>{i18n.getString(_TL_('Device targeting'))}: {targetConstraintsToText(item, 'Device', i18n)}</div>
              <div>{i18n.getString(_TL_('Age targeting'))}: {item.AgeRange || targetConstraintsToText(item, 'Age', i18n)}</div>
              <div>{i18n.getString(_TL_('Audience targeting'))}: {targetConstraintsToText(item, 'Audience', i18n)}</div>
              {isDealGenreRestricted && <div>{i18n.getString(_TL_('Genre targeting'))}: {item.Genre ? 'Available' : 'Unavailable'}</div>}
            </div>
          ),
        };
        return (
          <StyledAdTypeItem
            dealDetails={item}
            itemId={itemId}
            key={item.Id}
            onSelect={this.handleDealSelect}
            isSelected={(selectedDeal && selectedDeal.Id) === item.Id}
            ariaItemIndex={index + 1}
            i18n={i18n}
            {...configItem}
          />
        );
      });

      return options;
    }

    if (itemId === 'AdImpressions') {
      campaignTypeOptions = this.adImpressionCampaignType.map((item, index) => (
        <StyledAdTypeItem
          key={item.id}
          onSelect={this.handleAdImpressionsCampaignChannelSelect}
          isSelected={selectedAdImpressionsType === item.id}
          ariaItemIndex={index + 1}
          i18n={i18n}
          {...item}
        />
      ));
      return campaignTypeOptions;
    }

    if (itemId === 'SponsoredShoppingCampaign') {
      return sponsoredProductCampaignTypeConfig(i18n, permissions).map((item, index) => (
        <StyledAdTypeItem
          key={item.id}
          onSelect={this.handleSponsoredProductCampaignTypeSelect}
          isSelected={item.id === selectedSponsoredProductCampaignType}
          ariaItemIndex={index + 1}
          i18n={i18n}
          {...item}
        />
      ));
    }

    if (this.state.showPerfMaxCampaignTypeOptions) {
      const warningMessage = this.getConversionGoalWarningMessage(true);
      const campaignTypeLength = campaignTypeOptions.length;

      campaignTypeOptions.push(<StyledAdTypeItem
        key={this.perfMaxCampaignType.id}
        onSelect={this.handleCampaignTypeSelect}
        isSelected={selectedCampaignType === this.perfMaxCampaignType.id}
        ariaItemIndex={campaignTypeLength + 1}
        i18n={i18n}
        isNewFeature
        disabled={isPerfMaxCampaignDisabled}
        isPerfMaxWarningVisible={isPerfMaxCampaignDisabled}
        smartShoppingWarningMessage={isPerfMaxCampaignDisabled && warningMessage}
        {...this.perfMaxCampaignType}
      />);
    }

    if (this.state.showShoppingCampaignTypeOptions) {
      const warningMessage = isSmartShoppingCampaignEnabled && this.getSmartShoppingWarningMessage();
      const campaignTypeLength = campaignTypeOptions.length;

      const shoppingOptions = this.shopppingCampaignTypes.map((item, index) => {
        const isSmartShoppingDisabled = item.id === shoppingCampaignTypes.smart && this.state.isSmartShoppingCampaignDisabled;
        return (<StyledAdTypeItem
          key={item.id}
          onSelect={this.handleShoppingCampaignTypeSelect}
          isSelected={selectedCampaignType === item.id}
          ariaItemSize={campaignTypeLength + this.shopppingCampaignTypes.length}
          ariaItemIndex={campaignTypeLength + index + 1}
          {...item}
          disabled={isSmartShoppingDisabled}
          isSmartShoppingWarningVisible={isSmartShoppingDisabled}
          smartShoppingWarningMessage={isSmartShoppingDisabled && warningMessage}
          i18n={i18n}
        />);
      });
      campaignTypeOptions = campaignTypeOptions.concat(shoppingOptions);
      return campaignTypeOptions;
    } else if (itemId === 'ShoppingCampaign' && this.state.showPerfMaxCampaignTypeOptions) {
      const campaignTypeLength = campaignTypeOptions.length;

      campaignTypeOptions.push(<StyledAdTypeItem
        key={this.standardShoppingCampaignType.id}
        onSelect={this.handleShoppingCampaignTypeSelect}
        isSelected={selectedCampaignType === this.standardShoppingCampaignType.id}
        ariaItemIndex={campaignTypeLength + 1}
        i18n={i18n}
        {...this.standardShoppingCampaignType}
      />);
      return campaignTypeOptions;
    } else if (this.state.showPerfMaxCampaignTypeOptions) {
      const campaignTypeLength = campaignTypeOptions.length;

      campaignTypeOptions.push(<StyledAdTypeItem
        key={this.standardCampaignType.id}
        onSelect={this.handleCampaignTypeSelect}
        isSelected={selectedCampaignType === this.standardCampaignType.id}
        ariaItemIndex={campaignTypeLength + 1}
        i18n={i18n}
        {...this.standardCampaignType}
      />);
      campaignTypeOptions.push(<StyledAdTypeItem
        key={this.audienceCampaignType.id}
        onSelect={this.handleCampaignTypeSelect}
        isSelected={selectedCampaignType === this.audienceCampaignType.id}
        ariaItemIndex={campaignTypeLength + 2}
        i18n={i18n}
        {...this.audienceCampaignType}
      />);
      return campaignTypeOptions;
    }

    const searchAudienceOptions = this.adTypes.map((item, index) => (<StyledAdTypeItem
      key={item.id}
      onSelect={this.handleAdTypeSelect}
      isSelected={selectedAdType === item.id}
      ariaItemSize={this.adTypes.length}
      ariaItemIndex={index + 1}
      i18n={i18n}
      {...item}
    />));

    return searchAudienceOptions;
  }

  renderConsentCheckBox(i18n) {
    const { netflixDealTCAccepted } = this.state;
    return (
      <div>
        <Checkbox
          label={
            <>
              <span>{i18n.getString(_TL_('I have read and agree to the '))}</span>
              <Link href="https://about.ads.microsoft.com/en-us/microsoft-advertising-netflix-inventory-policy.pdf" target="_blank">
                {i18n.getString(_TL_('Netflix Inventory Policy'))}
              </Link>
              <span>{i18n.getString(_TL_('.'))}</span>
            </>
          }
          onChange={this.handleCheckNFDealIterm}
          disabled={this.isAcceptNetflixDealTCs(this.props)}
          defaultChecked={netflixDealTCAccepted}
        />
        <MessageBar>
          {i18n.getString(_TL_('Once you save your campaign, you cannot change your deal. If at some point you want to change your deal, you\'ll need to create a new campaign.'))}
        </MessageBar>
        <MessageBar>
          <span>
            {
              i18n.getString(_TL_('Advertisers in the following verticals are required to submit their licenses and/or proof of creative approval in select markets to serve their ads on Netflix: Alcohol, Financial Services, Insurance, High fat/sugar/salt foods, online sports betting, state-run lotteries, healthcare, pharmaceuticals, and dating.  Licenses and proof of creative approval can be submitted in web forms linked through the'))
            }
          </span>
          <Link href="https://help.netflix.com/legal/ad-restrictions" target="_blank">
            {i18n.getString(_TL_('Restricted policy page.'))}
          </Link>
        </MessageBar>
      </div>
    );
  }

  render() {
    const {
      i18n, isOpen, classes, onClose, isMMCSetup, permissions, isSmartShoppingCampaignEnabled
    } = this.props;
    const { itemId, deals, locationFilterOptions } = this.state;
    let optionsLength = 2;

    if (this.state.showPerfMaxCampaignTypeOptions && !(itemId === 'ShoppingCampaign' && !isSmartShoppingCampaignEnabled)) {
      optionsLength = 3;
    }

    const width = 1191 - ((3 - optionsLength) * 334);

    return (
      <Panel
        title={this.getPanelTitle()}
        isOpen={isOpen}
        onClose={onClose}
        width={width}
        panelClassName={`${classes.chooseObjectivePanel} choose-objective-panel ${itemId}`}
        i18n={this.props.i18n}
        panelReadyAriaLabel={i18n.getString(_TL_('Choose ad type side panel opened'))}
      >
        {
          permissions.IsDealFilterEnabled &&
          itemId === 'MediaPackageCampaign' &&
          deals.length > 0 &&
          <DealFilterBar i18n={i18n} deals={deals} onFilter={this.handleDealFilter} locationFilterOptions={locationFilterOptions} isEnabledDealsV2={this.props.permissions.IsEnabledDealsV2} />
        }
        <div className={classes.chooseAdsPanelBody} role="radiogroup" aria-label={this.getPanelTitle()}>
          {this.state.loading ? <Loading isVisible /> : this.renderOptions()}
        </div>
        {
          this.state.showShoppingCampaignTypeOptions && this.state.showPerfMaxCampaignTypeOptions && isBoolean(isMMCSetup) && !isMMCSetup &&
          <MessageBar
            isMultiline={false}
          >
            {i18n.getString(_TL_('No merchant center stores found. Create a store in Merchant Center in order to run product ads.'))}
          </MessageBar>
        }

        {
          itemId === 'MediaPackageCampaign' &&
          this.isNetflixDealSelected() &&
          this.renderConsentCheckBox(i18n)
        }

        <div className={classes.chooseAdsPanelFooter}>
          <Button
            className={`${classes.nextButton} next-button`}
            btnStyle="primary"
            disabled={this.isNextButtonDisabled()}
            onClick={this.handleNextButtonClick}
          >
            {i18n.getString(_TL_('Next'))}
          </Button>
          <Button className={`${classes.cancelButton} cancel-button`} onClick={onClose}>
            {i18n.getString(_TL_('Cancel'))}
          </Button>
        </div>
      </Panel>
    );
  }
}

ChooseAdsPanel.propTypes = {
  itemId: PropTypes.string.isRequired,
  isSmartShoppingCampaignEnabled: PropTypes.bool.isRequired,
  classes: PropTypes.shape(mapObject(
    getChooseAdsPanelStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  preferenceService: PropTypes.shape({}).isRequired,
  deals: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleNavigation: PropTypes.func.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      PMaxLite: PropTypes.bool,
    }).isRequired,
    IsAIMCampaignEnabled: PropTypes.bool.isRequired,
    IsDealFilterEnabled: PropTypes.bool.isRequired,
    IsSmartShoppingCampaignEnabled: PropTypes.bool.isRequired,
    IsDomesticSimplifiedChineseEnabled: PropTypes.bool,
    IsEnabledDealsV2: PropTypes.bool,
  }).isRequired,
  serverContext: PropTypes.shape({}).isRequired,
  showPerfMaxCampaignTypeOptions: PropTypes.bool,
  isMMCSetup: PropTypes.bool.isRequired,
};

ChooseAdsPanel.defaultProps = {
  onClose: () => { },
  showPerfMaxCampaignTypeOptions: false,
};

export const StyledChooseAdsPanel = withDefaultStyles(withI18nConsumer(withScope(withSiteMap(withPermissions(ChooseAdsPanel)))), getChooseAdsPanelStyles);
